module.exports = __webpack_public_path__ + "static/assets/d0658279229463ee5e53850f4cfea6d3.png";